import React from 'react';
import { useTranslation } from 'react-i18next';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

interface FormTabsProps {
  tab: 'details' | 'properties';
  add: boolean;
  onTabChange: (e: any, value: 'details' | 'properties') => void;
}

const FormTabs: React.FC<FormTabsProps> = ({ tab, add, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={onTabChange} textColor="primary">
        <Tab value="details" label={t('developers.addEdit.pageTexts.form.tabs.details')} />
        <Tab 
          value="properties" 
          label={t('developers.addEdit.pageTexts.form.tabs.properties')} 
          disabled={add}
        />
      </Tabs>
    </div>
  );
};

export default FormTabs;
